import { gql } from '@apollo/client';

export default gql`
  query search($q: String!) {
    search(q: $q)
  }
`;
